<script>
  import IconShelf from './IconShelf.svelte';

  export let books;
</script>

<style>
  .reel-item {
    display: block;
    /*width: 100px;*/
    /*height: 150px;*/
    /*background: #EEE;*/
    /*margin: 0 5px;*/
    padding: 5px;
    /*width: 200px;*/
    /*height: 200px;*/
  }
  .reel-item.small {
    /*width: 50px;
    height: 75px;
    margin: 10px;*/
  }

  .reel-item * {
    display: block;
  }

  .img-cont {
    /*margin: 0 auto;*/
    width:90px;
    height:133px;
    line-height: 133px;
    vertical-align: middle;
    flex-grow: 0;
  }

  img {
    /*display: block;*/
    vertical-align: middle;
    max-width:90px;
    max-height:133px;
    width: auto;
    height: auto;
    border-radius: 7px;
    /*margin: 0 auto;*/
    box-shadow: 0px 3px 16px -9px rgba(0,0,0,0.75);
  }
  .info {
    padding: 10px 0px 0px 10px;
    width: 170px;
    /*text-align: center;*/
  }
  .info.small {
    display: none;
  }
  .name {
    color: #333;
    font-weight: 600;
    /*padding-bottom: 5px;*/
    font-size: 14px;

    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }
  .author {
    color: #666;
    /*font-weight: 600;*/
    font-size: 12px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .availability {
    font-size: 12px;
  }
  .rating {
    font-size: 12px;
  }

  a {
    border-radius: 10px;
    /*background: #FFF;*/
    /*box-shadow: 0px 3px 16px -9px rgba(0,0,0,0.75);*/
    position:relative;
      z-index:2;
      color: inherit;
  }

  a:hover, a:active {
    background: #ff986e;
    box-shadow: 0px 3px 16px -9px rgba(0,0,0,0.75);
  }

  .reel-item-stuff {
    padding: 10px;
    display: flex;
    flex-direction: row;

  }
</style>

<div>
  {#each Object.entries(books) as [id, book]}
    <div class="reel-item">
      <a href="/book/{id}">
        <div class="reel-item-stuff">
          <div class="img-cont"><img src={book.image} /></div>
          <div class="info">
            <span class="name">{book.name}</span>
            <span class="author">{book.author || ""}</span>
            <span class="rating"><IconShelf icon="star" /> 4.3</span>
            <span class="availability">
              {#if book.available}
                <IconShelf icon="shelf" /> In shelf
              {:else}
                <IconShelf icon="no" /> Reservable
              {/if}
            </span>
          </div>
        </div>
      </a>
    </div>
  {/each}
</div>